import { z } from "zod";
import { newPasswordSchema } from "./account-credentials.js";
import { dealerPermissionDefinitions } from "./permissions.js";
const requiredText = (label, max) => z.string().trim().min(1, `${label}不能为空`).max(max, `${label}过长`);
const addressFields = {
    contactName: requiredText("联系人", 80),
    phone: requiredText("联系电话", 30),
    detail: requiredText("详细地址", 300),
    isDefault: z.boolean().optional(),
    active: z.boolean().optional(),
};
const existingAddress = z.object({
    id: z.string().uuid().transform((value) => value.toLowerCase()),
    contactName: addressFields.contactName.optional(),
    phone: addressFields.phone.optional(),
    detail: addressFields.detail.optional(),
    isDefault: addressFields.isDefault,
    active: addressFields.active,
}).strict().transform((input) => input.active === false ? { ...input, isDefault: false } : input);
const newAddress = z.object(addressFields).strict()
    .transform((input) => input.active === false ? { ...input, isDefault: false } : input);
export const customerEditorPatchSchema = z.object({
    code: requiredText("客户编码", 50).regex(/^[A-Za-z0-9_-]+$/, "客户编码只能包含字母、数字、横线和下划线").optional(),
    name: requiredText("客户名称", 160).optional(),
    contactName: requiredText("联系人", 80).optional(),
    phone: requiredText("联系电话", 30).optional(),
    active: z.boolean().optional(),
    username: requiredText("登录名", 80).regex(/^[A-Za-z0-9_.-]+$/, "登录名格式不正确").optional(),
    newPassword: newPasswordSchema.optional(),
    dealerPermissions: z.array(z.enum(dealerPermissionDefinitions.map(({ id }) => id))).max(dealerPermissionDefinitions.length).optional(),
    addresses: z.array(z.union([existingAddress, newAddress])).max(200, "一次最多修改 200 个地址").optional(),
}).strict().superRefine((input, context) => {
    if (!Object.keys(input).length)
        context.addIssue({ code: "custom", message: "没有需要更新的内容" });
    const ids = new Set();
    let defaults = 0;
    for (const [index, address] of (input.addresses ?? []).entries()) {
        if ("id" in address) {
            if (ids.has(address.id))
                context.addIssue({ code: "custom", message: "同一地址不能重复提交", path: ["addresses", index, "id"] });
            ids.add(address.id);
        }
        if (address.isDefault)
            defaults += 1;
    }
    if (defaults > 1)
        context.addIssue({ code: "custom", message: "只能指定一个默认地址", path: ["addresses"] });
});
